import { Injectable }       from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  CanLoad, Route
}                           from '@angular/router';
//************PROVIDER********* */
import { BasicProvider } from './../app/providers/basic/basic';
import { UserProvider } from './../app/providers/user/user';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private router: Router, public bp : BasicProvider, public up: UserProvider) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;

    return this.checkLogin(url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    let url = `/${route.path}`;
    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {
    if (this.up.isLoggedIn) { return true; }

    // Store the attempted URL for redirecting
    this.up.redirectUrl = url;

    // Create a dummy session id
    this.router.navigate(['/home']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth-guard.service.ts